import React from 'react';
import {connect} from 'react-redux';
import {change, Field} from "redux-form";

import ExpandSection from "../../Generic/expandSection";
import {toggleSectionOpened} from "../AccountActions";
import {ACCOUNT_SECTIONS} from "./sectionNames";
import {FormCheckBoxField, FormField, FormTextAreaField} from "../FormField";
import {store} from "../../../main";

class DepositsAndDisclaimers extends React.Component {

  // state = {
  //   defaultDepositDisclaimer: ""
  // };
  //
  // componentWillReceiveProps(nextProps) {
  //   if (!this.state.defaultDepositDisclaimer && nextProps.formValues.disclaimer
  //     && nextProps.formValues.disclaimer !== this.state.defaultDepositDisclaimer) {
  //     this.setState({
  //       defaultDepositDisclaimer: nextProps.formValues.disclaimer || ''
  //     });
  //   }
  //   if (!this.state.defaultDepositDisclaimer && nextProps.formValues.disclaimer
  //     && nextProps.formValues.disclaimer !== this.state.defaultDepositDisclaimer) {
  //     this.setState({
  //       defaultDepositDisclaimer: nextProps.formValues.disclaimer || ''
  //     });
  //   }
  // }

  updateCheckBoxField = (input) => {
    store.dispatch(change('newEntity', input.name, !input.value))
  };

  render() {
    return (
      <ExpandSection opened={this.props.sectionsOpened.includes(ACCOUNT_SECTIONS.deposits_and_disclaimers)}
                     onClick={() => this.props.toggleSectionOpened(ACCOUNT_SECTIONS.deposits_and_disclaimers)}
                     title="Deposits & Disclaimers">
        <div className="acc-container">
          <div className="acc-container__row">
            <div className="acc-block3">
              <Field name="enableDeposit" component={FormCheckBoxField} onChecked={this.updateCheckBoxField}
                     labelEnabled="Enable Deposit" doubleMargin={true} labelDisabled="Enable Deposit"/>
              <Field name="deposit" component={FormField} disabled={!this.props.formValues.enableDeposit}
                     label="Enter the Deposit Percentage"/>
              <Field name="depositMessage" component={FormTextAreaField} style={{height: "100px"}}
                     disabled={!this.props.formValues.enableDeposit} label="Edit Deposit Message"/>
              {/*<div className="acc-field text-right">*/}
              {/*  <button className="ui-button2 ui-button2--small ui-button2--blue"*/}
              {/*          onClick={() => store.dispatch(change('newEntity', 'deposit', this.state.defaultDepositDisclaimer))}>*/}
              {/*    Restore Default Deposit Message*/}
              {/*  </button>*/}
              {/*</div>*/}
            </div>
            <div className="acc-block3">
              <Field name="enableDisclaimer" component={FormCheckBoxField} onChecked={this.updateCheckBoxField}
                     labelEnabled="Enable Disclaimer" labelDisabled="Enable Disclaimer" doubleMargin={true} />
              <Field name="disclaimer" style={{height: "161px"}} component={FormTextAreaField}
                     disabled={!this.props.formValues.enableDisclaimer}
                     label="Edit Disclaimer Message"/>
              {/*<div className="acc-field text-right">*/}
              {/*  <button className="ui-button2 ui-button2--small ui-button2--blue"*/}
              {/*          onClick={() => store.dispatch(change('newEntity', 'disclaimer', this.state.defaultDepositDisclaimer))}>*/}
              {/*    Restore Default Disclaimer Message*/}
              {/*  </button>*/}
              {/*</div>*/}
            </div>
          </div>
        </div>
      </ExpandSection>
    )
  }

}

const mapStateToProps = (store) => {
  return {
    sectionsOpened: store.accountState.sectionsOpened,
    formValues: (store.form && store.form.newEntity && store.form.newEntity.values) || {}
  };
};

const mapDispatchToProps = {
  toggleSectionOpened
};

export default connect(mapStateToProps, mapDispatchToProps)(DepositsAndDisclaimers);

